/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse, HTTPResponse } from "../../../types";

export interface ActiveCall {
  call_id: string;
  caller_phone: string;
  caller_id: number;
  status: string;
  current_turn: number;
  total_messages: number;
  detected_user_name: string;
  conversation_state: string;
  start_time: Date | string;
  participants: {
    user: string;
    assistant: string;
  };
}

export interface AllCall{
  id: string;
  call_id: string;
  caller_id: number;
  user_id: number;
  user_name: string;
  caller_phone: string;
  status: string;
  start_time: Date;
  end_time: Date ;
  duration_seconds: number;
  user_participant: string;
  assistant_participant: string;
  created_at: string;
  messages: null | any[];
  message_count: number;
  summary: string | null;
  summary_generated_at: string | null;
}

export interface ActiveCallSType {
  active_calls: ActiveCall[];
  status: string;
  total_active: number;
}

export interface ICall {
  call_id: string;
  start_time: Date;
  end_time: Date ;
  duration_seconds: number;
  user_participant: string;
  assistant_participant: string;
}

export interface UserCall {
  id: number;
  user_id: number;
  user_name: string;
  user_phone: string;
  start_time: string;
  end_time: string;
  duration_seconds: number;
  message_count: number;
  status: string;
  summary: string | null;
  summary_generated_at: string | null;
}
    

export const getAllCall = async (params?: {
  name?: string | undefined;
  page?: number;
  limit?: number;
}) => {
  // Use proxy route for development to avoid CORS issues
  const response = await axiosInstance.get<GenericResponse<AllCall[]>>(`${import.meta.env.PROD 
    ? endpoints().calls.getAllCall 
    : `/api/v1${endpoints().calls.getAllCall}`}`, {
    params
  });
  return response.data;
};

export const getActiveCalls = async () => {
  // Use proxy route for development to avoid CORS issues
  const response = await axiosInstance.get<ActiveCallSType>(`${import.meta.env.PROD 
    ? endpoints().calls.getActiveCalls 
    : `/api/v1${endpoints().calls.getActiveCalls}`}`);
  return response.data;
};

export const getUserCallsById = async (userId: string | number): Promise<HTTPResponse<UserCall[]>> => {
  if (
    userId === undefined ||
    userId === null ||
    userId === '' ||
    userId === 'undefined' ||
    userId === 'null'
  ) {
    throw new Error("Invalid user ID provided.");
  }

  const response = await axiosInstance.get<HTTPResponse<UserCall[]>>(`${import.meta.env.PROD 
    ? endpoints(userId).calls.getUserCallsBId 
    : `/api/v1${endpoints(userId).calls.getUserCallsBId}`}`);
  return response.data;
}
